import React, { FC, MouseEventHandler } from 'react';
import Checkbox from '@cld/checkbox';
import { InlineFieldLayout, Label } from '@cld/form';

export interface CheckboxWithLabelProps {
  label: string;
  value: boolean;
  onClick: MouseEventHandler<HTMLElement>;
  fieldId: string;
  isDisabled?: boolean;
}

export const CheckboxWithLabel: FC<CheckboxWithLabelProps> = ({ label, value, onClick, fieldId, isDisabled = false }) => (
  <InlineFieldLayout label={<Label htmlFor={fieldId}>{label}</Label>}>
    <Checkbox
      id={fieldId}
      value={value}
      onClick={onClick}
      isDisabled={isDisabled}
      inputProps={{
        'data-test': `${fieldId}-checkbox`,
      }}
    />
  </InlineFieldLayout>
);
